"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHideRating = void 0;
var _fetching = require("@ori/fetching");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _utils = require("../utils");
/* istanbul ignore file @preserve */

const useHideRating = ({
  staticApiUrl,
  tenant,
  logger,
  enabled = true
}) => {
  const fetchKey = (0, _react.useMemo)(() => [staticApiUrl, tenant].join('-'), [staticApiUrl, tenant]);
  const {
    data: hideRating = true
  } = (0, _fetching.useSWR)(enabled ? fetchKey : null, async () => (0, _utils.resolveHideRating)({
    staticApiUrl,
    tenant,
    logger
  }), {
    ...(0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  return hideRating;
};
exports.useHideRating = useHideRating;
//# sourceMappingURL=useHideRating.js.map